import { render, staticRenderFns } from "./ShopContentForm.vue?vue&type=template&id=b9642eb4"
import script from "./ShopContentForm.vue?vue&type=script&lang=ts"
export * from "./ShopContentForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports